<template>
  <div class="nav">
    <ul class="">
      <li class="live_router"><router-link class="live_router" to="/live" data-title="Canlı Bahis">
        <div class="icon">
          <img src="@/assets/images/common/menu/sport.png" width="24">
        </div>
        <span>Canlı Bahis</span></router-link></li>
      <li class="sportsbook_router"><router-link class="sportsbook_router" to="/sportsbook" data-title="Spor Bahisleri">
        <div class="icon">
          <img src="@/assets/images/common/menu/live.png" width="24">
        </div>
        <span>Spor Bahisleri</span></router-link></li>
      <li class="slot_router"><router-link class="slot_router" to="/slot" data-title="Slot">
        <div class="icon">
          <img src="@/assets/images/common/menu/slot.png" width="24">
        </div>
        <span>Slot</span></router-link></li>
      <li class="casino_router"><router-link class="casino_router" to="/casino" data-title="Canlı Casino">
        <div class="icon">
          <img src="@/assets/images/common/menu/casino.png" width="24">
        </div>
        <span>Canlı Casino</span></router-link></li>
      <li class="virtual_router"><router-link class="virtual_router" to="/virtual" data-title="Sanal">
        <div class="icon">
          <img src="@/assets/images/common/menu/virtual.png" width="24">
        </div>
        <span>Sanal</span></router-link></li>
      <li class="bingo_router"><router-link class="bingo_router" to="/bingo" data-title="Tombala">
        <div class="icon">
          <img src="@/assets/images/common/menu/bingo.png" width="24">
        </div>
        <span>Tombala</span></router-link></li>
      <li class="high_flyer_router"><router-link class="high_flyer_router" lang="en" to="/highflyer" data-title="High Flyer"><div class="label-menu hot">Yeni</div>
        <div class="icon">
          <img src="@/assets/images/common/menu/highflyer.png" width="24">
        </div>
        <span>High Flyer</span></router-link></li>
      <li class="beton_router"><router-link class="beton_router" to="/beton" data-title="Betongames">
        <div class="icon">
          <img src="@/assets/images/common/menu/betongames.png" width="24">
        </div>
        <span>Betongames</span></router-link></li>
      <!-- <li class="binary_router"><router-link class="binary_router" to="/binary" data-title="Zeplin">
        <div class="icon">
          <img src="@/assets/images/common/menu/binary.png" width="24">
        </div>
        <span>Binary</span></router-link></li> -->
      <li class="zeppelin_router"><router-link class="zeppelin_router" to="/zeppelin" data-title="Zeplin">
        <div class="icon">
          <img src="@/assets/images/common/menu/zeppelin.png" width="24">
        </div>
        <span>Zeplin</span></router-link></li>
      <li class="aviator_router"><router-link class="aviator_router" to="/aviator" data-title="Aviator">
        <div class="icon">
          <img src="@/assets/images/common/menu/aviator.png" width="24">
        </div>
        <span>Aviator</span></router-link></li>
      <li class="spaceman_router"><router-link target="_blank" class="spaceman_router" to="/slot/pragmaticplay/all?game_id=74201&mobile=false" data-title="spaceman">
        <div class="icon">
          <img src="@/assets/images/common/menu/spaceman.png" width="24">
        </div>
        <span>Spaceman</span></router-link></li>
      <li class="jetx_router"><router-link target="_blank" class="jetx_router" to="/slot/smartsoft/all?game_id=75340&mobile=false" data-title="jetx">
        <div class="icon">
          <img src="@/assets/images/common/menu/jetx.png" width="24">
        </div>
        <span>JetX</span></router-link></li>
      <li class="milyoner_router"><a target="_blank" class="milyoner_router" href=" https://mersowins.com/" data-title="milyoner">
        <div class="icon">
          <img src="@/assets/images/common/menu/milyoner.png" width="24">
        </div>
        <span>MİLYONERLER</span></a></li>
      <li class="luckywheel_router" v-if="!user"  >
        <router-link  class="luckywheel_router" to="/auth/login"  data-title="luckywheel" exact-active-class="disable-active" active-class="disable-active">
        <div class="icon">
          <img src="@/assets/images/common/menu/luckywheels.png" width="24">
        </div>
        <span>Şans Çarkı</span></router-link></li>
      <li class="luckywheel_router" v-else><a  target="_blank" class="luckywheel_router" :href="'https://api.mersobahis.pro/wheel?username=' + user.username" data-title="luckywheel">
        <div class="icon">
          <img src="@/assets/images/common/menu/luckywheels.png" width="24">
        </div>
        <span>Şans Çarkı</span></a></li>
      <li class="mobileapp_router"><a target="_blank" class="mobileapp_router" href=" https://api.mersobahis.pro/mobile-app" data-title="mobileapp">
        <div class="icon">
          <img src="@/assets/images/common/menu/mobileapp.png" width="24">
        </div>
        <span>MOBİLE APP</span></a></li>
      <li class="call_router"><a target="_blank" class="call_router" href="https://api.mersobahis.pro/ara" data-title="call">
        <div class="icon">
          <img src="@/assets/images/common/menu/call.png" width="24">
        </div>
        <span>Beni Ara</span></a></li>
        <li class="ticket_router"><a target="_blank" class="ticket_router" href="https://api.mersobahis.pro/draw" data-title="ticket">
        <div class="icon">
          <img src="@/assets/images/common/menu/ticket.png" width="24">
        </div>
        <span>Etkinlikler</span></a></li>
    </ul>
  </div>
</template>

<script>
import RequestPage from './Request.vue'
export default{
  data(){
    return{
              type: '',
              bonus_modal: false,
    }
  },
  components:{
    RequestPage
  },
  computed:{
    configSpesific(){ 
      return this.$store.getters['special/getConfigSpesific']
    },
    specialMenu(){
      return this.$store.getters['special/getMenu']
    },
    user(){
      return this.$user();
    },
    url(){
      let url = this.$store.getters['special/bonusUrl']
      if(this.$auth()){
        url = url + this.user.username;
      }
      return url
    },
    is_poker(){
      return this.$store.getters.getPokerStatus
    },
  }
}
</script>

<style lang="scss">
  li.other-g{
    position: relative;
    >a:hover{
        ul{
          display: flex !important;
        }
    }
    ul{
        position: absolute;
        display: none !important;
        z-index: 999;
        background: var(--client-header-menu);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        top: 50px;
        left: 0px;
        width: auto !important;
      li{
        a{
          padding: 10px 20px !important;
        }
      }
    }
  }

</style>